import { useCallback, useEffect, useRef, useState } from "react";
import {
  isImportOnboardingSnoozed,
  readImportOnboardingRecord,
  writeImportOnboardingRecord,
} from "@/features/home/onboarding/import-onboarding-nudge.logic";

const REMIND_LATER_MS = 24 * 60 * 60 * 1000;

function getBrowserStorage(): Storage | undefined {
  if (typeof window === "undefined") return undefined;
  return window.localStorage;
}

export function useImportOnboardingNudge(workspaceId: string | undefined) {
  const [record, setRecord] = useState(() =>
    readImportOnboardingRecord(workspaceId, getBrowserStorage()),
  );
  const lastWorkspaceRef = useRef(workspaceId);

  useEffect(() => {
    if (lastWorkspaceRef.current === workspaceId) return;
    lastWorkspaceRef.current = workspaceId;
    setRecord(readImportOnboardingRecord(workspaceId, getBrowserStorage()));
  }, [workspaceId]);

  const remindLater = useCallback(() => {
    const next = { snoozedUntil: Date.now() + REMIND_LATER_MS };
    writeImportOnboardingRecord(workspaceId, next, getBrowserStorage());
    setRecord(next);
  }, [workspaceId]);

  return {
    snoozed: isImportOnboardingSnoozed(record),
    remindLater,
  };
}
